// Kanban drag-and-drop shared by the CRM pipeline and HR boards.
// The board owns the data attributes; this module only moves cards and
// reports the drop. The caller persists it and calls move.revert() on failure.
export function bindKanban(board, opts) {
    if (!board || board.dataset.kanbanBound) return;
    board.dataset.kanbanBound = '1';
    const canDrop = opts.canDrop || (() => true);
    let dragging = null, dragHome = null, dragNext = null;
    board.addEventListener('dragstart', (e) => {
        const card = e.target.closest('.kb-card'); if (!card || card.getAttribute('draggable') === 'false') return;
        dragging = card; dragHome = card.parentElement; dragNext = card.nextElementSibling; card.classList.add('dragging'); e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', card.dataset.id);
    });
    board.addEventListener('dragend', () => { if (dragging) dragging.classList.remove('dragging'); dragging = null; board.querySelectorAll('.kb-col.over').forEach((c) => c.classList.remove('over')); });
    board.addEventListener('dragover', (e) => {
        if (!dragging) return;
        const col = e.target.closest('.kb-col'); if (!col || !canDrop(dragging, col)) return;
        e.preventDefault(); e.dataTransfer.dropEffect = 'move';
        board.querySelectorAll('.kb-col.over').forEach((c) => { if (c !== col) c.classList.remove('over'); });
        col.classList.add('over');
        const cards = col.querySelector('.kb-cards');
        const after = Array.from(cards.querySelectorAll('.kb-card:not(.dragging)')).find((c) => e.clientY < c.getBoundingClientRect().top + c.offsetHeight / 2);
        if (after) cards.insertBefore(dragging, after); else cards.appendChild(dragging);
    });
    board.addEventListener('drop', (e) => {
        if (!dragging) return;
        e.preventDefault();
        const col = e.target.closest('.kb-col'); if (!col || !canDrop(dragging, col)) return;
        const card = dragging, home = dragHome, homeNext = dragNext; dragging = null; card.classList.remove('dragging'); col.classList.remove('over');
        const stage = col.dataset.stage;
        const prev = card.previousElementSibling, next = card.nextElementSibling;
        const lo = prev ? Number(prev.dataset.order) || 0 : 0;
        const hi = next ? Number(next.dataset.order) || lo + 2 : lo + 2;
        const order = (lo + hi) / 2;
        const before = { stage: card.dataset.stage, order: card.dataset.order || '0' };
        card.dataset.stage = stage; card.dataset.order = String(order);
        const revert = () => {
            card.dataset.stage = before.stage; card.dataset.order = before.order;
            if (home) { if (homeNext && homeNext.parentElement === home) home.insertBefore(card, homeNext); else home.appendChild(card); }
        };
        opts.onDrop(card, { stage, order, before, revert });
    });
}
